import { render, staticRenderFns } from "./DeleteCustomersModal.vue?vue&type=template&id=09cf6e15&scoped=true"
import script from "./DeleteCustomersModal.vue?vue&type=script&lang=js"
export * from "./DeleteCustomersModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteCustomersModal.vue?vue&type=style&index=0&id=09cf6e15&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf6e15",
  null
  
)

export default component.exports